import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/login/login'
import Main from '@/main/main'
import OrderAudit from '@/page/orderaudit'
import OrderAuditPending from '@/page/orderaudit/pending'
import OrderAuditProcessed from '@/page/orderaudit/processed'
import Partner from '@/page/partner'
import OrganList from '@/page/partner/organlist'
import OrganAdd from '@/page/partner/organadd'
import OrganSet from '@/page/partner/organset'
import OrganDetails from '@/page/partner/organdetails'
import BankAcceptance from '@/page/bankacceptance'
import BusinessAuth from '@/page/bankacceptance/businessauth'
import BusinessTicket from '@/page/bussinessticket'
import TicketList from '@/page/bussinessticket/ticketlist'
import ProjectMol from '@/page/bussinessticket/projectMol'
import realEstate from '@/page/bussinessticket/realEstate'
import Refusal from '@/page/bussinessticket/refusal'
import businessadvertisements from '@/page/bussinessticket/businessadve'
import getred from '@/page/bussinessticket/getred'
import PayAuth from '@/page/bankacceptance/payauth'
import PayAuthentication from '@/page/bankacceptance/payauthentication'
import DiscountData from '@/page/bankacceptance/discountdata'
import Interestrate from '@/page/bankacceptance/interestrate'
import BankManagement from '@/page/bankacceptance/bankmanagement'
import Advertisements from '@/page/bankacceptance/advertisements'
import AdvList from '@/page/bankacceptance/advlist'
import AdRepair from '@/PAGE/bankAcceptance/adrepair'
import Channel from '@/PAGE/bankAcceptance/Channel'
import Webankintrupdate from '@/page/bankacceptance/webankintrupdate'
import Toto from '@/PAGE/bankAcceptance/toto'
import Custom from '@/PAGE/bankAcceptance/custom'
import Fedex from '@/PAGE/bankAcceptance/fedex'
import CustomInfo from '@/PAGE/bankAcceptance/custominfo'
import Control from '@/PAGE/bankAcceptance/control'
import barCode from '@/PAGE/barCode/index'

import SendControl from '@/PAGE/bankAcceptance/sendcontrol'
import ControlInfo from '@/PAGE/bankAcceptance/controlinfo'
import Static from '@/PAGE/bankAcceptance/static'
import Recom from '@/PAGE/bankAcceptance/recom'
// 订单异常处理
import OrderException from '@/page/orderexception'
import OrderHall from '@/page/orderexception/OrderHall'
// import Overtime from '@/page/orderexception/overtime'
import WaitConfirm from '@/page/orderexception/waitconfirm'
import FirstOvertime from '@/page/orderexception/firstovertime'
import SecondOvertime from '@/page/orderexception/secondovertime'
import UrgedSign from '@/page/orderexception/urgedsign'
import UnreceivedBill from '@/page/orderexception/unreceivedbill'
import RefusedSign from '@/page/orderexception/refusedsign'
import OrderDetail from '@/page/orderexception/orderdetail'

import Exchangetrue from '@/page/orderexception/exchangetrue'
import Exchangetran from '@/page/orderexception/exchangetran'
import Exchangecomp from '@/page/orderexception/exchangecomp'
import Exchangeclos from '@/page/orderexception/exchangeclos'
import Exchangeinfo from '@/page/orderexception/exchangeinfo'

import Exchangeuser from '@/page/orderexception/exchangeuser'
import Bilsindex from '@/page/orderexception/bilsindex'


// 静态页面
import CompanyPage from '@/page/companypage'


Vue.use(Router)
export default new Router({
    mode: 'history',
    routes: [
        { path: '/', name: 'Login', component: Login },
        { path: '/main', name: 'Main', component: Main },
        { path: '/advlist', name: 'AdvList', component: AdvList },
        {
            path: '/orderaudit',
            name: 'OrderAudit',
            component: OrderAudit,
            children: [
                { path: '/orderaudit/pending', name: 'OrderAuditPending', component: OrderAuditPending },
                { path: '/orderaudit/processed', name: 'OrderAuditProcessed', component: OrderAuditProcessed }
            ]
        },
        {
            path: '/partner',
            name: 'Partner',
            component: Partner,
            children: [
                { path: '/partner/organlist', name: 'OrganList', component: OrganList },
                { path: '/partner/organadd', name: 'OrganAdd', component: OrganAdd },
                { path: '/partner/organset', name: 'OrganSet', component: OrganSet },
                { path: '/partner/organlist/organdetails', name: 'OrganDetails', component: OrganDetails }
            ],
            redirect: "/partner/organlist"
        },
        {
            path: '/bankacceptance',
            name: 'BankAcceptance',
            component: BankAcceptance,
            children: [
                { path: '/bankacceptance/businessauth', name: 'BusinessAuth', component: BusinessAuth },
                { path: '/bankacceptance/payauth', name: 'PayAuth', component: PayAuth },
                { path: '/bankacceptance/payauthentication', name: 'PayAuthentication', component: PayAuthentication },
                { path: '/bankacceptance/discountdata', name: 'DiscountData', component: DiscountData },
                { path: '/bankacceptance/interestrate', name: 'Interestrate', component: Interestrate },
                { path: '/bankacceptance/bankmanagement', name: 'BankManagement', component: BankManagement },
                { path: '/bankacceptance/advertisements', name: 'advertisements', component: Advertisements },
                { path: '/bankacceptance/advlist', name: 'AdvList', component: AdvList },
                { path: '/bankacceptance/advrepair', name: 'AdRepair', component: AdRepair },
                { path: '/bankacceptance/channel', name: 'Channel', component: Channel },
                { path: '/bankacceptance/webankintrupdate', name: 'Webankintrupdate', component: Webankintrupdate },
                { path: '/bankacceptance/Toto', name: 'Toto', component: Toto },
                { path: '/bankacceptance/Custom', name: 'Custom', component: Custom },
                { path: '/bankacceptance/Fedex', name: 'Fedex', component: Fedex },
                { path: '/bankacceptance/CustomInfo', name: 'CustomInfo', component: CustomInfo },
                { path: '/bankacceptance/Control', name: 'Control', component: Control },
				{ path: '/barCode/index', name: 'barCode', component: barCode },
                { path: '/bankacceptance/SendControl', name: 'SendControl', component: SendControl },
                { path: '/bankacceptance/ControlInfo', name: 'ControlInfo', component: ControlInfo },
				
                { path: '/bankacceptance/Static', name: 'Static', component: Static },
                { path: '/bankacceptance/recom', name: 'Recom', component: Recom }
            ],
            redirect: "/bankacceptance/businessauth"
        },
        {
            path: '/businessticket',
            name: 'BusinessTicket',
            component: BusinessTicket,
            children: [
                { path: '/businessticket/ticketlist', name: 'TicketList', component: TicketList },
                { path: '/businessticket/Refusal', name: 'Refusal', component: Refusal },
                { path: '/businessticket/ProjectMol', name: 'ProjectMol', component: ProjectMol },
                { path: '/businessticket/realEstate', name: 'realEstate', component: realEstate },
                { path: '/businessticket/advertisements', name: 'businessadvertisements', component: businessadvertisements },
                { path: '/businessticket/getred', name: 'getred', component: getred },
            ],
            redirect: "/businessticket/ticketlist"
        },
        // 订单异常处理
        {
            path: '/orderexception',
            name: 'OrderException',
            component: OrderException,
            children: [
                // {path:'/orderexception/overtime',name:'Overtime',component:Overtime},
                { path: '/orderexception/waitconfirm', name: 'WaitConfirm', component: WaitConfirm },
                { path: '/orderexception/firstovertime', name: 'FirstOvertime', component: FirstOvertime },
                { path: '/orderexception/secondovertime', name: 'SecondOvertime', component: SecondOvertime },
                { path: '/orderexception/urgedsign', name: 'UrgedSign', component: UrgedSign },
                { path: '/orderexception/unreceivedbill', name: 'UnreceivedBill', component: UnreceivedBill },
                { path: '/orderexception/refusedsign', name: 'RefusedSign', component: RefusedSign },
                { path: '/orderexception/Exchangetrue', name: 'Exchangetrue', component: Exchangetrue },
                { path: '/orderexception/Exchangetran', name: 'Exchangetran', component: Exchangetran },
                { path: '/orderexception/Exchangecomp', name: 'Exchangecomp', component: Exchangecomp },
                { path: '/orderexception/Exchangeclos', name: 'Exchangeclos', component: Exchangeclos },
                { path: '/orderexception/Exchangeinfo', name: 'Exchangeinfo', component: Exchangeinfo },
                { path: '/orderexception/Exchangeuser', name: 'Exchangeuser', component: Exchangeuser },
                { path: '/orderexception/Bilsindex', name: 'Bilsindex', component: Bilsindex },
            ],
            // redirect:"/orderexception/waitconfirm"
        },
        { path: '/orderhall', name: 'OrderHall', component: OrderHall },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js